import { ChangeEvent, useCallback, useState } from "react";
import { IOption } from "@evergis/ui";

export const useCreateNewAttribute = () => {
  const [newAttributeType, setType] = useState(null);
  const [newAttributeName, setName] = useState("MassEdit");

  const onChangeAttributeType = useCallback(
    (option: IOption[]) => {
      setType(option[0]);
    },
    [setType],
  );

  const onChangeAttributeName = useCallback(
    (evt: ChangeEvent<HTMLInputElement>) => {
      setName(evt.target.value);
    },
    [setName],
  );

  return { onChangeAttributeName, onChangeAttributeType, newAttributeName, newAttributeType };
};
